import { configureStore } from "@reduxjs/toolkit";
import { isDev, isDebugMode } from "common/utils";
import userSlice from "features/user/slice";
import accountSlice from "features/account/slice";
import messageSlice from "features/message/slice";
import playerSlice from "features/player/slice";
import { subscriptionSlice } from "features/subscription";
import configSlice from "./configSlice";

export const store = configureStore({
  reducer: {
    config: configSlice,
    user: userSlice,
    subscription: subscriptionSlice,
    account: accountSlice,
    message: messageSlice,
    player: playerSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: isDev || isDebugMode,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
